module.exports = __webpack_public_path__ + "media/check-weights.ea682015.mp4";